import { matchPath } from 'react-router';

type PathMatchable = {
    path?: string;
    exact?: boolean;
};

// Matches the way the router does: case-insensitive, by whole segments, ignoring a trailing slash.
const matchesPath = (item: PathMatchable, pathname: string): item is { path: string } =>
    item.path !== undefined && matchPath({ path: item.path, end: !!item.exact }, pathname) !== null;

/**
 * The drawer item a path belongs to: the item with the longest path that is the path itself
 * or one of its parent segments, honoring `exact`. Undefined when no item covers the path.
 */
export const drawerItemForPath = <T extends PathMatchable>(
    items: readonly T[],
    pathname: string,
): T | undefined =>
    items.reduce<T | undefined>((best, item) => {
        if (!matchesPath(item, pathname)) {
            return best;
        }
        return best?.path !== undefined && best.path.length >= item.path.length ? best : item;
    }, undefined);
